import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  input,
  output,
  viewChild,
} from '@angular/core';
import { LoadingUIComponent } from '../../../atoms/loading/loading.component';

/** Matches `.autocomplete-item` height, so the list fits a whole number of items. */
export const AUTOCOMPLETE_ITEM_HEIGHT = 50;
export const AUTOCOMPLETE_VISIBLE_ITEMS = 9;
/** Items still hidden below the viewport when the next page is requested. */
export const AUTOCOMPLETE_LOAD_MORE_THRESHOLD = 3;

@Component({
  selector: 'fr8bot-ui-autocomplete-content',
  imports: [LoadingUIComponent],
  templateUrl: './autocomplete-content.component.html',
  styleUrl: './autocomplete-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AutocompleteContentUIComponent {
  readonly loadingMore = input(false);

  readonly scrolledToEnd = output<void>();

  private readonly scroller = viewChild.required<ElementRef<HTMLElement>>('scroller');

  protected readonly maxHeight = AUTOCOMPLETE_ITEM_HEIGHT * AUTOCOMPLETE_VISIBLE_ITEMS;

  scrollToTop(): void {
    this.scroller().nativeElement.scrollTop = 0;
  }

  protected onScroll(): void {
    const { scrollHeight, scrollTop, clientHeight } = this.scroller().nativeElement;
    const hiddenBelow = scrollHeight - scrollTop - clientHeight;

    if (hiddenBelow <= AUTOCOMPLETE_LOAD_MORE_THRESHOLD * AUTOCOMPLETE_ITEM_HEIGHT) {
      this.scrolledToEnd.emit();
    }
  }
}
